module.exports = __webpack_public_path__ + "static/media/37_KlausSiebald_webfinal.e0aef2c4.jpg";